import { Badge, RingProgress, Text, Tooltip } from '@mantine/core';
import type { InboxWindowState } from './types';

/** Unified messaging-window indicator: a countdown ring (WhatsApp) or a
 *  tri-state badge (Instagram/Messenger), or nothing. */
export function WindowBadge({ state }: { state: InboxWindowState }) {
  if (state.variant === 'none') return null;
  if (state.variant === 'ring') {
    return (
      <Tooltip label={state.tooltip ?? state.label ?? ''} disabled={!state.tooltip && !state.label}>
        <RingProgress
          size={34}
          thickness={3}
          roundCaps
          sections={[{ value: state.ringPercent ?? 0, color: state.color ?? 'teal' }]}
          label={
            <Text size="9px" ta="center">
              {state.label ?? ''}
            </Text>
          }
        />
      </Tooltip>
    );
  }
  return (
    <Tooltip label={state.tooltip ?? ''} disabled={!state.tooltip}>
      <Badge color={state.color ?? 'gray'} variant="light" size="sm">
        {state.label ?? ''}
      </Badge>
    </Tooltip>
  );
}
